// notificationMiddleware.js

import { toast } from "react-toastify";
import {markNotificationsAsReadThunk} from "./notificationThunks";

let markAllAsRead;
export const notificationMiddleware = storeAPI => next => action => {
    if (action.type === 'notifications/markAsRead') {
        try {
            const { notificationIds } = action.payload;

            // Dispatch thunk and handle it as a promise
            Promise.resolve(
                storeAPI.dispatch(markNotificationsAsReadThunk({ notificationIds }))
            ).catch(error => {
                console.error("Failed to mark all notifications as read:", error);
                toast.error('Something went wrong!')
            });
        } catch (error) {
            console.error("Failed to mark all notifications as read:", error);
            toast.error('Something went wrong!')
        }
    }

    return next(action); // Make sure to call next with the original action
};
